/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {StyleSheet} from 'aphrodite/no-important';

const styles = StyleSheet.create({
	loader: {
		margin: 'auto',
		width: '72px'
	},
	loaderContainer: {
		alignItems: 'center',
		display: 'flex',
		minHeight: '100vh'
	}
});

export default styles;
